/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Form from "../../../components/Form";
import useForm from "../../../hooks/useForm";
import Modal, { ModalHeader } from "../../../components/Modal";
import { cloneDeep, isEmpty, isEqual } from "lodash";
import systemAlert from "../../../utils/systemAlert";
import { createWorkOthers, modifyWorkOthers } from "../../../apis/work-schedule/other-work";
import { findModeLabel } from "../../../utils/mode";

const OtherWork = ({ selectedData, open, setOpen, submit, mode }) => {
  const [fields] = useState([
    { title: "기타 근무명", key: "workName", type: "input", required: true },
    { title: "필요 사유", key: "description", type: "input" },
    {
      title: "사용 여부",
      key: "isActive",
      type: "radio",
      options: {
        list: [
          { label: "사용", value: "1" },
          { label: "미사용", value: "0" },
        ],
      },
    },
  ]);

  const defaultForm = {
    workName: "",
    description: "",
    isActive: "1",
  }

  const _submit = (form) => {
    const _form = cloneDeep(form)
    _form.isActive === "1" ? _form.isActive = true : _form.isActive = false;
    if (mode === 'create') {
      systemAlert(`${form.workName} 기타근무를 등록하시겠습니까?`, {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '등록',
            onClick: () => {
              createWorkOthers(_form)
                .then(() => {
                  cancel()
                  submit()
                })
                .catch(() => { })
                .finally(() => { })
            }
          }
        ]
      })
    } else {
      systemAlert(`${form.workName} 기타근무를 수정하시겠습니까?`, {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '수정',
            onClick: () => {
              modifyWorkOthers(selectedData.workIdx, _form)
                .then(() => {
                  cancel()
                  submit()
                })
                .catch(() => { })
                .finally(() => { })
            }
          }
        ]
      })
    }
  };

  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    originForm,
    setOriginForm,
    setValidateFields
  } = useForm(
    defaultForm,
    _submit,
  );

  useEffect(() => {
    setValidateFields(fields)

    if (!isEmpty(selectedData)) {
      const _selectedData = cloneDeep(selectedData)
      _selectedData.isActive ? _selectedData.isActive = "1" : _selectedData.isActive = "0";
      setForm(_selectedData)
      setOriginForm(_selectedData)
    } else {
      setForm(defaultForm)
      setOriginForm(defaultForm)
    }

  }, [open, selectedData, fields])


  const cancel = (e) => {
    setOpen(false);
  };

  const getSubmitDisabled = () => {
    let disabled = false

    if (mode === 'modify') {
      isEqual(originForm, form) ? disabled = true : disabled = false
    }

    return disabled
  }

  return (
    <Modal isOpen={open} close={cancel}>
      <div className="notice-write">
        <ModalHeader>
          기타 근무 항목 {findModeLabel(mode)}
        </ModalHeader>
        <Form
          mode={mode}
          fields={fields}
          form={form}
          onChange={handleOnChange}
          submit={handleSubmit}
          cancel={cancel}
          errors={errors}
          isRequiredShow={true}
          isDisabledSubmit={getSubmitDisabled()}
        />
      </div>
    </Modal>
  );
};

export default OtherWork;
